/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import $ from 'jquery'
import { openInNewTab } from '@/js/utils/utils'

async function handleLoginNeeded(app) {
    /** @type {ModalManager} */
    const modalManager = app.get('modalManager')
    const { isConfirmed } = await modalManager.info(
        'You will be redirected to the login page in a new tab to avoid any data loss.',
        'You are not logged in'
    )

    if (isConfirmed) {
        openInNewTab(app.get('reloginUrl'))
    }
}

function handleOnRelogin() {
    if (!window.opener) {
        return
    }

    window.opener.document.dispatchEvent(new Event('app.relogged'))
    window.close()
}

/**
 * Intercept 401 responses and prompt the user to re-login in a new tab.
 * Bound once at boot.
 *
 * @type {Module}
 */
export default function init({ app }) {
    const url = new URL(window.location.href)
    if (url.searchParams.has('fromRelogin')) {
        handleOnRelogin()
    }

    document.addEventListener('turbo:before-fetch-response', (event) => {
        const { fetchResponse } = event.detail

        if (fetchResponse.response.headers.has('x-login-needed')) {
            event.preventDefault()
            Turbo.navigator.adapter.hideVisitProgressBar()
            handleLoginNeeded(app)
        }
    })

    $(document).on('ajaxComplete', (_, xhr) => {
        if (!xhr.getResponseHeader('x-login-needed')) {
            return
        }

        handleLoginNeeded(app)
    })

    document.addEventListener('app.relogged', () => {
        /** @type {ModalManager} */
        const modalManager = app.get('modalManager')
        modalManager.close()

        modalManager.toast('success', 'You are logged in back again.')
    })
}
